import { useKeycloak } from "@react-keycloak/web";
import { Avatar, Button, Dropdown } from "antd";
import { useAppDispatch, useAppSelector } from "../../../app/store";
import BottomDropdownIcon from "../../../assets/icons/BottomDropdownIcon";
import LogoutIcon from "../../../assets/icons/LogoutIcon";
import { userLoggedOut } from "../../../features/auth/authSlice";
import { capitalize } from "../../../utils/string";
import { underscoreToCapitalizeString } from "../../../utils/utils";

export default function ProfileMenu() {
  const dispatch = useAppDispatch();
  const { user, role } = useAppSelector((state) => state.auth);
  const { keycloak } = useKeycloak();

  const handleLogout = async () => {
    try {
      await keycloak.logout();
      dispatch(userLoggedOut());
    } catch (error) {
      console.error("Logout failed", error);
    }
  };

  return (
    <Dropdown
      placement="bottomRight"
      arrow={{ pointAtCenter: true }}
      className="cursor-pointer"
      rootClassName="profile-menu !left-auto !right-5 !bg-transparent"
      dropdownRender={() => (
        <ul className="list-none p-1 rounded flex justify-center">
          <Button
            onClick={handleLogout}
            // onClick={() => dispatch(userLoggedOut())}
            className="py-1.5 px-8 cursor-pointer select-none bg-[#f8384b] text-sm rounded h-10 text-white hover:!text-white flex items-center"
            icon={<LogoutIcon />}
          >
            Logout
          </Button>
        </ul>
      )}
    >
      <div className="flex items-center gap-2.5 cursor-pointer">
        <Avatar size={44} />
        <div className="text-base flex items-center gap-2.5">
          <div>
            <h6 className="dark:text-white text-others-body text-sm font-medium">
              {underscoreToCapitalizeString(user?.name || "")}
            </h6>
            <small className="dark:text-header text-body text-xs font-normal">
              {capitalize(role || "")}
            </small>
          </div>
          <div className="dark:text-[#D7DFE9] text-[#8897AE]">
            <BottomDropdownIcon />
          </div>
        </div>
      </div>
    </Dropdown>
  );
}
